import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faChevronDown } from "@fortawesome/free-solid-svg-icons";
import { useLayout } from "@/contexts/LayoutContext";
import { useQuickTask } from "@/contexts/QuickTaskContext";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuSeparator, DropdownMenuTrigger } from "@/components/shadcn/dropdown-menu";

export const NewTaskButton = () => {
  const { data } = useLayout();
  const { openQuickTask } = useQuickTask();
  const routes = data.appRoutes;

  const addTaskUrl = () =>
    `/AddTask.aspx?location=${encodeURIComponent(window.location.pathname + window.location.search)}&`;

  const isQuickDefault = data.newTaskDefaultFull !== true;
  return (
    <div className="flex items-center group">
      {isQuickDefault ? (
        <button
          type="button"
          onClick={openQuickTask}
          className="flex items-center gap-1 px-3 h-8 text-sm font-medium text-white bg-(--layout-brand) hover:bg-(--layout-brand-hover) transition-colors cursor-pointer border border-white/40 group-hover:border-white rounded-l-[6px] border-r-0"
        >
          <FontAwesomeIcon icon={faPlus} size="sm" />
          <span className="hidden lg:inline">New Task</span>
        </button>
      ) : (
        <a
          href={addTaskUrl()}
          className="flex items-center gap-1 px-3 h-8 text-sm font-medium text-white bg-(--layout-brand) hover:bg-(--layout-brand-hover) transition-colors cursor-pointer border border-white/40 group-hover:border-white rounded-l-[6px] border-r-0"
        >
          <FontAwesomeIcon icon={faPlus} size="sm" />
          <span className="hidden lg:inline">New Task</span>
        </a>
      )}

      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <button
            className="flex items-center justify-center w-6 h-8 text-white bg-(--layout-brand) hover:bg-(--layout-brand-hover) transition-colors border border-white/40 group-hover:border-white rounded-r-[6px] focus:outline-none"
            aria-label="More task options"
          >
            <FontAwesomeIcon icon={faChevronDown} size="xs" />
          </button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="start" className="min-w-40">
          <DropdownMenuItem onSelect={openQuickTask}>
            Quick Task
          </DropdownMenuItem>
          <DropdownMenuItem asChild>
            <a href={addTaskUrl()}>Full Task</a>
          </DropdownMenuItem>
          <DropdownMenuSeparator />
          <DropdownMenuItem asChild>
            <a href={routes.addProspect}>New Prospect</a>
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
}
